import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="min-h-[80vh] grid place-items-center px-5 pt-32 grid-lines" data-testid="not-found">
      <div className="text-center">
        <p className="font-display text-8xl font-extrabold text-blue-600">404</p>
        <p className="mt-4 text-slate-600">This page doesn't exist.</p>
        <Link to="/" className="mt-8 inline-flex rounded-full bg-slate-900 text-white px-6 py-3 font-semibold" data-testid="not-found-home-btn">Go home</Link>
      </div>
    </section>
  );
}
